import { NavLink } from "react-router-dom";
import { appName, nav as navCopy } from "../../copy/sq";
import { NAV_ITEMS } from "./navItems";

export function Sidebar() {
  return (
    <aside className="hidden w-60 shrink-0 flex-col border-r border-ink-100 bg-white/70 px-3 py-5 lg:flex">
      <div className="mb-6 px-2">
        <p className="font-serif text-lg font-semibold leading-tight text-ink-950">{appName.short}</p>
        <p className="text-xs font-medium uppercase tracking-wide text-ink-400">Inteligjencë</p>
      </div>

      <nav className="flex flex-1 flex-col gap-0.5" aria-label={navCopy.mainNavigationLabel}>
        {NAV_ITEMS.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors ${
                isActive ? "bg-accent-50 text-accent-700" : "text-ink-600 hover:bg-ink-50 hover:text-ink-900"
              }`
            }
          >
            <Icon className="shrink-0" />
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="px-2 pt-3 text-xs text-ink-400">
        <p>{navCopy.privateAccessOnly}</p>
      </div>
    </aside>
  );
}
